export default {"src":"/_next/static/media/aury.5f1b762d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};